import React, { Fragment, useEffect, useState } from "react";
import { log } from "@assets/js/utils";

import { motion, useTransform } from "framer-motion";

import './timeline-number-display.scss';


const TimelineNumberDisplay = ({debugMode, sectionCount, values, scrollYProgress, progressPct, durPct}) => {


  const [oldScrollProgressPct,setOldScrollYProgress] = useState(-1);

  const [textHeight] = useState(200);

  const [currentItemIndex, setCurrentItemIndex] = useState(0);
  const [currentValue, setCurrentValue] = useState(values[0]);



  const [currentOpacityValues] = useState([1,1,0,0]);
  const [nextOpacityValues] = useState([0,0,1,1]);
  const [yValues] = useState([0,0,-textHeight, -textHeight]);
  
  const [currentOpacityTriggers, setCurrentOpacityTriggers] = useState([0,0,1,1]);
  const [currentYTriggers, setCurrentYTriggers] = useState([0,0,1,1]);  
  const [nextOpacityTriggers, setNextOpacityTriggers] = useState([0,0,1,1]);  
  const [nextYTriggers, setNextYTriggers] = useState([0,0,1,1]);

  


  const yTransformCurrent = useTransform( scrollYProgress, currentYTriggers, yValues );
  const opacityTransformCurrent = useTransform( scrollYProgress, currentOpacityTriggers, currentOpacityValues );  
  
  const yTransformNext = useTransform( scrollYProgress, nextYTriggers, yValues );
  const opacityTransformNext = useTransform( scrollYProgress, nextOpacityTriggers, nextOpacityValues );  


  const convertToPct = val => Math.trunc(val*100)+'%';


  // determince, what values should be in the three containers, shared, current and next

  useEffect(() => {

    if (debugMode) log("TIMELINE | TND | progressPct="+convertToPct(progressPct));

    // skip logic, if there are no sections
  
    if ( sectionCount && oldScrollProgressPct !== progressPct ) {

      setOldScrollYProgress(progressPct);

      let valC, valN, valCT, valNT = 0;
      
      
      if (progressPct > values[sectionCount-1].threshold ) {
        
        // if we've gone beyound the last registered threshold, use last el
        
        valC = values[sectionCount-1];
        valCT = valC.threshold;
        setCurrentItemIndex(sectionCount-1);
      }
      else if ( progressPct < values[0].threshold - durPct ) {
        
        // if we haven't yet reaced the first registered threshold, use first el
        
        valC = values[0];
        valCT = valC.threshold;
        setCurrentItemIndex(0);
      } else {

        // ELSE: find the el whose threshold matches the scroll pos

        for (let i = 0; i<sectionCount; i++) {
          valC = values[i];
          valN = i < sectionCount-1 ? values[i+1] : null;
          valCT = valC && valC.threshold;
          valNT = valN ? valN.threshold : 1;
          
          if ( progressPct >= valCT-durPct && progressPct < valNT - durPct ) {  
              setCurrentItemIndex(i);              
              break;
          }
        }
      }
      
      // update transform triggers to animate current content

      setCurrentValue(valC);
      setCurrentOpacityTriggers([0, valCT - durPct, valCT - durPct*0.5, 1]);
      setCurrentYTriggers([0, valCT - durPct*0.9, valCT, 1]);
      setNextOpacityTriggers([0, valCT - durPct*1.2, valCT - durPct*0.5, 1]);
      setNextYTriggers([0, valCT - durPct*1.1, valCT,  1]);
    }
  }, [currentItemIndex, scrollYProgress, progressPct, values, sectionCount, durPct, oldScrollProgressPct, currentValue, debugMode]);



  return (
    <div className="timeline-number-display">
      {debugMode && <small>INDEX: {currentItemIndex}; SCROLL: {convertToPct(progressPct)}</small>}
      
      <h1 className="timeline-number-display__inner">
          
        {currentValue && <>
          <span className="timeline-number-display__shared">
            {currentValue.shared && currentValue.shared.split('').map((letter,index)=>{
              return (
                <Fragment key={`sharedLetter${index}`}>
                  <em>{letter}</em>
                </Fragment>
              );
            })}
          </span>
          <motion.span className="timeline-number-display__current" style={{opacity:opacityTransformCurrent, y: yTransformCurrent}}>
            {currentValue.current && currentValue.current.split('').map((letter,index)=>{
              return (
                <Fragment key={`currentLetter${index}`}>
                  <em>{letter}</em>
                </Fragment>
              );
            })}
            {currentValue.currentIsDecade ? <strong>&rsquo;</strong> : <em></em>}
          </motion.span>
          <motion.span className="timeline-number-display__next" style={{opacity:opacityTransformNext, y: yTransformNext}}>
            {currentValue.next && currentValue.next.split('').map((letter,index)=>{
              return (
                <Fragment key={`nextLetter${index}`}>
                  <em>{letter}</em>
                </Fragment>
              );
            })}  
            {currentValue.nextIsDecade ? <strong>&rsquo;</strong> : <em></em>}
            </motion.span>
        </>}
      </h1>
    </div>
  );
}

export default TimelineNumberDisplay;
